import { render, staticRenderFns } from "./VImg.vue?vue&type=template&id=4e70727a"
import script from "./VImg.vue?vue&type=script&lang=js"
export * from "./VImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports